import { render, staticRenderFns } from "./ImportFile.vue?vue&type=template&id=a900d6e8&scoped=true"
import script from "./ImportFile.vue?vue&type=script&lang=js"
export * from "./ImportFile.vue?vue&type=script&lang=js"
import style0 from "./ImportFile.vue?vue&type=style&index=0&id=a900d6e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a900d6e8",
  null
  
)

export default component.exports